import { isE2EUser } from '@mentimeter/user';
import type { EvaluationContext } from '@openfeature/react-sdk';
import { formatISO } from 'date-fns/formatISO';

const DEFAULT_REGION = 'eu';
type Region = 'eu' | 'us';

interface UserEvaluationContextParams {
  userId: number;
  userRegion: Region | undefined;
  userEmail: string;
  userCreatedAt: string;
  userPlanCategory: string;
  userFeaturesType: string;
  organizationType: string | undefined;
  mainUsage: string | undefined;
  workRole: string | undefined;
}

export interface UserEvaluationContext {
  user_id: string;
}

export function getUserEvaluationContext({
  userId,
  userRegion = 'eu',
  userEmail,
  userCreatedAt,
  userPlanCategory,
  userFeaturesType,
  organizationType,
  mainUsage,
  workRole,
}: UserEvaluationContextParams): UserEvaluationContext & EvaluationContext {
  // IMPORTANT! Do not send personally identifiable information to Confidence until we have a data protection agreement with them in place
  return {
    user_id: regionalizeUserId(userId, userRegion),
    is_e2e_user: isE2EUser(userEmail),
    user_created_at: formatISO(userCreatedAt),
    is_mentimeter_user: isMentimeterUser(userEmail),
    is_dev_user: isMentimeterUser(userEmail) && userEmail.includes('+dev'),
    plan: userPlanCategory,
    plan_feature_type: userFeaturesType,
    organization_type: organizationType ?? 'unknown',
    main_usage: mainUsage ?? 'unknown',
    work_role: workRole ?? 'unknown',
  };
}

function regionalizeUserId(
  userId: number,
  region: Region | undefined = DEFAULT_REGION,
) {
  return region === 'us' ? `us${userId}` : String(userId);
}

function isMentimeterUser(userEmail: string) {
  return (
    userEmail.endsWith('@mentimeter.com') ||
    userEmail.endsWith('@mentimeter.us') ||
    userEmail.endsWith('@menti.com') ||
    userEmail.endsWith('@mentimeter.dev') ||
    userEmail.endsWith('@mentimeter.ninja') ||
    userEmail.endsWith('@menti.ninja')
  );
}
